module.exports = __webpack_public_path__ + "img/natural_material.3123e6a0.svg";